import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Gallery',
    href: '#gallery'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Blog',
    href: '#blog'
  }];
  return <>
      <header className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-white/95 backdrop-blur-sm py-5'}`} data-id="element-106">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
          <div className="flex justify-between items-center" data-id="element-108">
            {/* Logo */}
            <div className="flex-shrink-0" data-id="element-109">
              <a href="#" className="block" data-id="element-110">
                <img src="https://cdn.magicpatterns.com/uploads/8s4d9srHFAq5QBzYs3roqy/logo-2023-d.png" alt="BLC Custom Homes, Inc" className="h-10 md:h-12 w-auto" data-id="element-111" />
              </a>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8" data-id="element-112">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-brand-black hover:text-brand-blue font-medium transition-colors" data-id="element-113">
                  {link.name}
                </a>)}
            </nav>

            {/* Desktop Actions */}
            <div className="hidden lg:flex items-center space-x-6" data-id="element-114">
              <a href="tel:559-288-0499" className="flex items-center text-brand-blue font-semibold hover:opacity-80 transition-colors" data-id="element-115">
                <Phone className="w-5 h-5 mr-2" data-id="element-116" />
                559-288-0499
              </a>
              <a href="#contact" className="bg-brand-blue hover:bg-opacity-90 text-white px-6 py-2.5 font-semibold transition-colors shadow-md" data-id="element-117">
                Get a Free Quote
              </a>
            </div>

            {/* Mobile Menu Button */}
            <div className="lg:hidden flex items-center" data-id="element-118">
              <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-brand-blue p-2" aria-label="Toggle mobile menu" data-id="element-119">
                {isMobileMenuOpen ? <X className="w-7 h-7" data-id="element-120" /> : <Menu className="w-7 h-7" data-id="element-121" />}
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay - rendered OUTSIDE header to avoid stacking context issues */}
      {isMobileMenuOpen && <div className="lg:hidden fixed inset-0 top-[72px] bg-white z-[9999] overflow-y-auto" data-id="element-122">
          <div className="flex flex-col px-6 py-8 space-y-6" data-id="element-123">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-2xl font-semibold text-brand-blue" onClick={() => setIsMobileMenuOpen(false)} data-id="element-124">
                {link.name}
              </a>)}
            <div className="pt-8 border-t border-gray-200 flex flex-col space-y-6" data-id="element-125">
              <a href="tel:559-288-0499" className="flex items-center text-xl font-semibold text-brand-blue" data-id="element-126">
                <Phone className="w-6 h-6 mr-3 text-brand-orange" data-id="element-127" />
                559-288-0499
              </a>
              <a href="#contact" className="bg-brand-blue text-white text-center px-6 py-4 font-semibold text-lg shadow-md" onClick={() => setIsMobileMenuOpen(false)} data-id="element-128">
                Get a Free Quote
              </a>
            </div>
          </div>
        </div>}
    </>;
}